import React from "react";
import PlateauCard from "./PlateauCard";
import "./Plateaux.css";

/* ============================================================
   PLATEAUX GRID
   ------------------------------------------------------------
   Rôle :
   - afficher tous les types de plateaux
   - gérer la sélection visuelle
   - transmettre le plateau choisi au parent

   Props attendues :
   plateaux                → liste des plateaux disponibles
   plateauSelectionne      → plateau actuellement choisi
   onSelect                → fonction pour sélectionner
   t                       → traductions
   ============================================================ */

export default function PlateauxGrid({
  plateaux = [],
  plateauSelectionne,
  onSelect,
  t = {},
}) {
  return (
    <div className="plateaux-grid">
      {plateaux.map((plateau) => (
        <PlateauCard
          key={plateau.id}
          plateau={plateau}
          /* -----------------------------
             sélection visuelle active
          ----------------------------- */
          selected={plateauSelectionne?.id === plateau.id}
          /* -----------------------------
             action sélection
          ----------------------------- */
          onSelect={onSelect}
          t={t}
        />
      ))}
    </div>
  );
}
